import { ReactNode } from 'react';

import {
  Header,
  Footer,
  Body,
  Panel,
} from 'view-layer/components/layout';

interface BasePanelProps {
  children?: ReactNode
  payment: any,
  withActions?: boolean,
}

export const BasePanel: React.FC<BasePanelProps> = ({ children, payment, withActions = false }) => {

  return (
    <Panel variant="light" key="0">
      <Header payment={payment} />
      <Body>
        {children}
      </Body>
      {withActions && <Footer payment={payment} />}
    </Panel>
  );
}
